<template>
  <div class="order-submission">
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <div>
        <div class="item acea-row row-between-wrapper">
          <div>供奉位置</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请选择供奉位置"
              style="color:#b37536;"
              v-model="orderGroupInfo.cartInfo[0].fqSelect"
              disabled
              oninput="value=value.replace(/[^\d.]/g,'')"
            />
          </div>
        </div>
        <!-- <div class="item acea-row row-between-wrapper">
          <div>供奉时间</div>
          <div class="discount">
            <input
              type="text"
              style="color:#c8a86b;"
              v-model="consecrateTime"
              disabled
              oninput="value=value.replace(/[^\d.]/g,'')"
            />
          </div>
        </div> -->
        <div class="item acea-row row-between-wrapper">
          <div>随喜金额(元)</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写随喜金额（单位元）"
              style="color:#b37536;"
              v-model="amount"
              disabled
              oninput="value=value.replace(/[^\d.]/g,'')"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>功德主姓名</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写功德主姓名"
              style="color:#b37536"
              v-model="realName"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>联系电话</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系电话"
              style="color:#b37536"
              v-model="phone"
            />
          </div>
        </div>
      </div>
      <div class="item">
        <div style="float:left">祈福文</div>
        <div style="float:right;color:#b37536;text-decoration:underline">祈福语</div>

        <textarea
          placeholder="请输入祈福文（150字以内）"
          style="color:#b37536"
          v-model="mark"
        ></textarea>
      </div>
      <!-- <div class="item acea-row row-between-wrapper">
          <div>供奉位置</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请选择供奉位置"
              style="color:#c8a86b;"
              v-model="amount"
              disabled
              oninput="value=value.replace(/[^\d.]/g,'')"
            />
          </div>
        </div> -->
    </div>
    <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="'on'"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="'bounceIn'"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <!-- <div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              余额支付
            </div>
            <div class="tip">可用余额：{{ userInfo.nowMoney || 0 }}</div>
          </div> -->
        </div>
      </div>
    </div>
    
    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="settlement" @click="createOrder">支付并点亮祈福灯</div>
    </div>
    <!-- <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.totalPrice"
      :cartid="cartid"
      :checked="usableCoupon.id"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow> -->
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}

.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}

.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #eb3729 0%, #eb3729 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #eb3729 0%,
    #eb3729 100%
  );
  background-image: -moz-linear-gradient(to bottom, #eb3729 0%, #eb3729 100%);
  padding-top: 1rem;
}

.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .allAddress .nav .item {
  width: 3.55rem;
}

.order-submission .allAddress .nav .item.on {
  position: relative;
}

.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0.4rem;
  border-style: solid;
  border-color: #fff;
  z-index: 9;
  text-align: center;
  line-height: 0.14rem;
}

.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0.4rem;
}

.order-submission .allAddress .nav .item.on2 {
  position: relative;
}

.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0.4rem;
  border-style: solid;
  border-color: #d5e6e6;
  text-align: center;
  line-height: 0.14rem;
}

.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0.4rem;
}

.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}

.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
</style>
<script>
import OrderGoods from "@components/OrderGoodsTime";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";

const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  data: function() {
    return {
      consecrateTime:"",
      realName:"",
      phone:"",
      mark:"",
      productId:"",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      enableIntegral: true,
      enableIntegralNum: 0,
      isWeixin: _isWeixin,
      pinkId: 0,
      // active: _isWeixin ? "weixin" : "yue",
      active: "weixin",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      useIntegral: false,
      productAttrUnique:"",
      orderPrice: {
        payPrice: "计算中"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      cartid: ""
    };
  },
  computed: mapGetters(["userInfo", "storeItems"]),
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) this.getCartInfo();
    },
    shipping_type() {
      this.computedPrice();
    }
  },
  mounted: function() {
    let that = this;
    that.getCartInfo();
    // alert(that.$route.query.product_id)
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;

    if (that.$route.params.id !== undefined)
      that.cartid = that.$route.params.id;
  },
  methods: {
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
      console.log("index2:" + this.shipping_type);
    },
    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1
      }).then(res => {
        const data = res.data;
        if (data.status === "EXTEND_ORDER") {
          this.$router.replace({
            path: "/order/detail/" + data.result.orderId
          });
        } else {
          this.orderPrice = data.result;
        }
      });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      //alert(this.$route.params.productId)
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.enableIntegral = res.data.enableIntegral;
          this.enableIntegralNum = res.data.enableIntegralNum;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.systemStore || {};
          this.store_self_mention = res.data.storeSelfMention;


          this.productId=res.data.cartInfo[0].productId;
          this.productAttrUnique=res.data.cartInfo[0].productAttrUnique;


          if(res.data.addressInfo){
              this.realName=res.data.addressInfo.realName
              this.phone=res.data.addressInfo.phone
              this.mark=res.data.addressInfo.detail
          }
          if(res.data.cartInfo!=null&&res.data.cartInfo.length>0){
            this.amount=res.data.cartInfo[0].productInfo.attrInfo.price
            this.consecrateTime=res.data.cartInfo[0].productInfo.attrInfo.sku
          }
          
         // alert(this.productAttrUnique)

          // this.computedPrice();
        })
        .catch(() => {
          this.$dialog.error("加载订单数据失败");
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      console.log(9999);
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      console.log("coupon:" + coupon);
      if (!coupon) {
        this.usableCoupon = { couponTitle: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },
    createOrder() {
      let shipping_type = this.shipping_type;
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });

      if (this.amount == "" || this.amount == null){
        return this.$dialog.toast({ mes: "请填写随喜金额" });
      }
      // if (this.amount < 1 ){
      //   return this.$dialog.toast({ mes: "随喜金额需大于1元" });
      // }
      
      // if(this.realName!=null&&this.realName!=""){
      //   if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.realName)) {
      //       return this.$dialog.toast({ mes: "请填写正确的功德主姓名" });
      //   }
      // }
      
      if(this.phone!=null&&this.phone!=""){
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.phone)) {
            return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
      }

      this.$dialog.loading.open("生成订单中");

      createOrder(this.orderGroupInfo.orderKey, {
        amount:this.amount,
        realName: this.realName,
        phone: this.phone,
        mark: this.mark || "",
        from: this.from,

        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        payType: this.active,
        pinkId: this.pinkId,
        seckillId: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        
        shippingType: parseInt(shipping_type) + 1,
        storeId: this.storeItems.id || this.system_store.id,
        productId:this.productId,
        productAttrUnique:this.productAttrUnique,
        fqSelect:orderGroupInfo.cartInfo[0].fqSelect
      })
        .then(res => {
          this.$dialog.loading.close();
          const data = res.data;
          // alert(data.status)
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              this.$router.replace({
                path: "/order/detail/" + data.result.orderId
              });
              break;
            case "SUCCESS":
              this.$dialog.success(res.msg);
              this.$router.replace({
                path: "/order/detail/" + data.result.orderId
              });
              break;
            case "WECHAT_H5_PAY":
              this.$router.replace({
                path: "/order/detail/" + data.result.orderId
              });
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                this.$router.replace({
                  path: "/order/detail/" + data.result.orderId
                });
              });
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.loading.close();
          this.$dialog.error(err.msg || "创建订单失败");
        });
    }
  }
};
</script>
